import React from "react";
import "./styles.scss";
import ExpandableRow from "./ExpandableRow";
import { TiArrowSortedDown } from "react-icons/ti";

export interface TeamData {
  id: string;
  name: string;
  status: string;
  country: string;
  members: TeamMemberData[];
  onClick(id: string): void;
  onEdit?(id: string): void;
}

export interface TeamMemberData {
  id: string;
  fullName: string;
  email: string;
}

interface Order {
  current: "TEAM-NAME" | "STATUS" | "COUNTRY";
  teamName: "ASCENDING" | "DESCENDING";
  status: "ASCENDING" | "DESCENDING";
  country: "ASCENDING" | "DESCENDING";
}
interface IProps {
  onStatusUpdate: (isLoading: boolean) => void;
  orders: Order;
  onOrderUpdate: (order: Order) => void;
  teams: TeamData[];
}

const ExpandableTable = (props: IProps) => {
  return (
    <table className="expandable-table">
      <thead>
        <tr style={{ backgroundColor: "#006699", color: "#fff" }}>
          <th></th>
          <th
            style={{ cursor: "pointer" }}
            onClick={() =>
              props.onOrderUpdate({
                ...props.orders,
                current: "TEAM-NAME",
                teamName:
                  props.orders.teamName === "ASCENDING"
                    ? "DESCENDING"
                    : "ASCENDING",
              })
            }
          >
            Team Name{" "}
            <TiArrowSortedDown
              className="order-arrow"
              style={
                props.orders.current === "TEAM-NAME"
                  ? props.orders.teamName === "ASCENDING"
                    ? { transform: "rotate(0deg)" }
                    : {
                        transform: "rotate(180deg) translateY(2px)",
                      }
                  : { color: "#aaa" }
              }
            />
          </th>
          <th
            style={{ cursor: "pointer" }}
            onClick={() =>
              props.onOrderUpdate({
                ...props.orders,
                current: "STATUS",
                status:
                  props.orders.status === "ASCENDING"
                    ? "DESCENDING"
                    : "ASCENDING",
              })
            }
          >
            Status{" "}
            <TiArrowSortedDown
              className="order-arrow"
              style={
                props.orders.current === "STATUS"
                  ? props.orders.status === "ASCENDING"
                    ? { transform: "rotate(0deg)" }
                    : {
                        transform: "rotate(180deg) translateY(2px)",
                      }
                  : { color: "#aaa" }
              }
            />
          </th>
          <th
            style={{ cursor: "pointer" }}
            onClick={() =>
              props.onOrderUpdate({
                ...props.orders,
                current: "COUNTRY",
                country:
                  props.orders.country === "ASCENDING"
                    ? "DESCENDING"
                    : "ASCENDING",
              })
            }
          >
            Country{" "}
            <TiArrowSortedDown
              className="order-arrow"
              style={
                props.orders.current === "COUNTRY"
                  ? props.orders.country === "ASCENDING"
                    ? { transform: "rotate(0deg)" }
                    : {
                        transform: "rotate(180deg) translateY(2px)",
                      }
                  : { color: "#aaa" }
              }
            />
          </th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {props.teams.map((team, index) => (
          <ExpandableRow
            onStatusUpdate={props.onStatusUpdate}
            key={index}
            team={team}
          />
        ))}
      </tbody>
    </table>
  );
};

export default ExpandableTable;
